import React from "react";
import { LoginPage } from "./login-page";

export const SectionLayout: React.FC<any> = (_props) => {
  return (
    <LoginPage/>
  );
};
